var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"authority"},[_c('el-row',{staticClass:"images",attrs:{"gutter":20}},_vm._l((_vm.images),function(item,index){return _c('el-col',{key:index,staticClass:"image",attrs:{"xs":24,"span":6,"lg":12,"md":12,"xl":6}},[_c('el-image',{attrs:{"preview-src-list":_vm.imageSrcList,"fit":"contain","src":item.url,"lazy":""}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }